/* tslint:disable */
/* eslint-disable */
/**
 * Stututu API
 * REST API for the Stututu car community.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  Me401Response,
} from '../models/index';
import {
    Me401ResponseFromJSON,
    Me401ResponseToJSON,
} from '../models/index';

export interface MarkASingleNotificationAsReadRequest {
    id: string;
}

/**
 * NotificationsApi - interface
 * 
 * @export
 * @interface NotificationsApiInterface
 */
export interface NotificationsApiInterface {
    /**
     * Returns the authenticated user\'s notifications, newest first. Optional `filter[unread]=1` restricts to unread only. Paginated via `per_page`.
     * @summary List notifications
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApiInterface
     */
    listNotificationsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Returns the authenticated user\'s notifications, newest first. Optional `filter[unread]=1` restricts to unread only. Paginated via `per_page`.
     * List notifications
     */
    listNotifications(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Mark a single notification as read
     * @param {string} id The ID of the notification.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApiInterface
     */
    markASingleNotificationAsReadRaw(requestParameters: MarkASingleNotificationAsReadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * 
     * Mark a single notification as read
     */
    markASingleNotificationAsRead(requestParameters: MarkASingleNotificationAsReadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Mark all notifications as read
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApiInterface
     */
    markAllNotificationsAsReadRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * 
     * Mark all notifications as read
     */
    markAllNotificationsAsRead(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Lightweight endpoint for the header bell badge. Returns a single integer.
     * @summary Unread notification count
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApiInterface
     */
    unreadNotificationCountRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Lightweight endpoint for the header bell badge. Returns a single integer.
     * Unread notification count
     */
    unreadNotificationCount(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

}

/**
 * 
 */
export class NotificationsApi extends runtime.BaseAPI implements NotificationsApiInterface {

    /**
     * Returns the authenticated user\'s notifications, newest first. Optional `filter[unread]=1` restricts to unread only. Paginated via `per_page`.
     * List notifications
     */
    async listNotificationsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("default", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/notifications`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Returns the authenticated user\'s notifications, newest first. Optional `filter[unread]=1` restricts to unread only. Paginated via `per_page`.
     * List notifications
     */
    async listNotifications(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.listNotificationsRaw(initOverrides);
    }

    /**
     * 
     * Mark a single notification as read
     */
    async markASingleNotificationAsReadRaw(requestParameters: MarkASingleNotificationAsReadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling markASingleNotificationAsRead().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("default", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/notifications/{id}/read`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * 
     * Mark a single notification as read
     */
    async markASingleNotificationAsRead(requestParameters: MarkASingleNotificationAsReadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.markASingleNotificationAsReadRaw(requestParameters, initOverrides);
    }

    /**
     * 
     * Mark all notifications as read
     */
    async markAllNotificationsAsReadRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("default", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/notifications/read-all`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * 
     * Mark all notifications as read
     */
    async markAllNotificationsAsRead(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.markAllNotificationsAsReadRaw(initOverrides);
    }

    /**
     * Lightweight endpoint for the header bell badge. Returns a single integer.
     * Unread notification count
     */
    async unreadNotificationCountRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("default", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/notifications/unread-count`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Lightweight endpoint for the header bell badge. Returns a single integer.
     * Unread notification count
     */
    async unreadNotificationCount(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.unreadNotificationCountRaw(initOverrides);
    }

}
